module.exports = __webpack_public_path__ + "static/media/landscaping.f49ee40a.png";